import React from 'react';
import PropTypes from 'prop-types';
import { Swiper } from 'swiper/dist/js/swiper.esm.js';
import ReactIdSwiper from 'react-id-swiper/lib/ReactIdSwiper.custom';
import MobileFilmTile from 'components/MobileFilmTile/MobileFilmTile';
import _ from 'lodash';
import './mobile-film-tiles.scss';
import './swiper.scss';

const listCinemas = movie => _.uniqBy(
  movie.schedule.map(sche => sche.cinemas.map(sch => ({
    icon: sch.logo,
    name: sch.name,
  }))).flat(1),
  'icon',
);

class MobileFilmTiles extends React.Component {
  state = {
    rebuildOnUpdate: false,
    selectedDate: this.props.selectedDate,
    selectedCinema: this.props.selectedCinema,
    searchField: this.props.searchField,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selectedDate !== prevState.selectedDate
      || nextProps.selectedCinema !== prevState.selectedCinema
      || nextProps.searchField !== prevState.searchField) {
      return {
        rebuildOnUpdate: true,
        searchField: nextProps.searchField,
        selectedDate: nextProps.selectedDate,
        selectedCinema: nextProps.selectedCinema,
      };
    }
    return {
      rebuildOnUpdate: false,
    };
  }

  render() {
    const { filteredMovies, dispatchOpenModal, activeModal, brandClass, hours, minutes, selectedDate, brand } = this.props;
    const { rebuildOnUpdate } = this.state;
    const params = {
      Swiper,
      spaceBetween: -window.innerWidth / 20 * 3,
      on: {
        slideChange: () => {
          this.forceUpdate();
        },
      },
    };
    return (
      <div className={activeModal.title ? 'none' : 'react-film-tiles-container-mobile'}>
        {
          filteredMovies[0] ? (
            <ReactIdSwiper {...params} rebuildOnUpdate={rebuildOnUpdate}>
              {
                filteredMovies.map(movie => (
                  <MobileFilmTile
                    {...movie}
                    cinemaList={listCinemas(movie)}
                    onModalClick={dispatchOpenModal}
                    tabIndex={movie.movieId}
                    activeModal={activeModal}
                    key={movie.movieId}
                    brandClass={brandClass}
                    hours={hours}
                    minutes={minutes}
                    selectedDate={selectedDate}
                    brand={brand}
                  />
                ))
              }
            </ReactIdSwiper>
          )
            : null
        }
      </div>
    );
  }
}

MobileFilmTiles.propTypes = {
  filteredMovies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeModal: PropTypes.shape({
    playtime: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  dispatchOpenModal: PropTypes.func.isRequired,
  brandClass: PropTypes.string,
  brand: PropTypes.number.isRequired,
  hours: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired,
  searchField: PropTypes.string.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedCinema: PropTypes.string.isRequired,
};

MobileFilmTiles.defaultProps = {
  brandClass: 'react-artmozi',
};

export default MobileFilmTiles;
